import React from "react";
import { Container } from "react-bootstrap";

type AccessDeniedProps = {
  /** Optional name of the feature the user was denied access to. */
  featureName?: string;
};

export default function AccessDenied({ featureName }: AccessDeniedProps) {
  const target = featureName ? `the ${featureName}` : "this page";
  return (
    <Container className="py-5">
      <div
        className="bg-white rounded p-4 shadow-sm mx-auto text-center"
        style={{ maxWidth: 640 }}
      >
        <h1 className="h3 mb-3">Access denied</h1>
        <p className="mb-0">
          You do not have access to {target}. Please sign in with an authorized
          employee account or contact your administrator.
        </p>
      </div>
    </Container>
  );
}
